import {
  WSButton,
  WSButtons,
  WSForm,
  WSText,
  WSInputTextarea
} from "@wingspanhq/fe-component-library";
import { InvoiceRow } from "@wingspanhq/wingspan-api-sdk";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesInvoiceRows, queriesInvoices } from "@query";

type Props = {
  invoice: InvoiceRow;
  onClose: () => void;
};

export const ModalDispute: React.FC<Props> = ({ invoice, onClose }) => {
  const [disputeInvoice, disputeInvoiceMeta] =
    queriesInvoices.disputeInvoice.useMutation({
      dependencies: [
        queriesInvoiceRows.searchInvoiceRows.queryKeyBase,
        queriesInvoices.getInvoice.queryKeyBase
      ]
    });

  return (
    <WSForm<{ disputeComment: string }>
      onSubmit={({ disputeComment }) => {
        if (!invoice.id) {
          return;
        }
        disputeInvoice(
          {
            invoiceId: invoice.id,
            disputeInvoiceRequest: { reason: disputeComment }
          },
          {
            onSuccess: onClose
          }
        );
      }}
    >
      <WSText mb="XL">
        Indicate the reason for the dispute in the field below
      </WSText>

      <WSForm.Field mb="XL" name="disputeComment" component={WSInputTextarea} />

      <ErrorAlert
        mb="XL"
        error={disputeInvoiceMeta.error}
        context="DisputeInvoice"
      />

      <WSButtons format="modal">
        <WSButton name="disputeInvoice" loading={disputeInvoiceMeta.isLoading}>
          Dispute invoice
        </WSButton>
        <WSButton.Secondary
          name="disputeInvoice"
          onClick={onClose}
          type="button"
        >
          Cancel
        </WSButton.Secondary>
      </WSButtons>
    </WSForm>
  );
};
